// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"130":"8e06aa94","546":"a8d96ceb","731":"9166413c","818":"38a37524","847":"0153b2c9","954":"bc601fcd"}[chunkId] + ".chunk.css";
};